import AddIcon from "../../../assets/Images/icons/AddIcon";
import Card from "../../../components/Card"
import Headings from "../../../components/Texts/Headings";
import Paragraphs from "../../../components/Texts/Paragraphs";

const ApplyNowCard = () => {
  return (
    <div className="flex flex-col md:hidden">
      <Card className={"flex flex-col pb-0 px-0 pt-0 overflow-hidden"}>
        <div className="flex justify-between px-[28px] py-[18px]">
          <div>
            <Headings
              className="!font-Apparat"
              text="Available Credit"
            />
          </div>
          <div className="flex flex-col justify-end gap-[4px]">
            <Headings
              variant="tertiary"
              className="!font-Apparat"
              text="Rs 1,00,000"
            />
            <Paragraphs
              text="Of Rs 2,00,000"
              variant="tertiary"
              className="!font-[500] text-[#42495250] text-end"
            />

          </div>
        </div>
        {/* <progress value="3333" max="10000" className="w-full h-2 !rounded-none !appearance-none !overflow-hidden">
          33%
        </progress> */}
        {/* custom progress bar */}
        <div class="w-full h-2 bg-gray-200 overflow-hidden">
          <div class="h-full bg-[#262626] " style={{ width: "33%" }}></div>
        </div>
      </Card>
      <div className="flex justify-center font-Apparat font-[600] text-[12px] md:text-[16px]  leading-[28px] md:eading-[24px] mt-[20px] text-[#000] gap-[16px]">
        <AddIcon className="h-[19px] w-[19px] md:h-[23px] md:w-[23px] bg-primary text-white rounded-full " />
        <span>Apply Now</span>
      </div>
    </div>)
}

export default ApplyNowCard;